"use strict";
var from_1 = require('./from');
exports.fromCallback = from_1.default;
var to_1 = require('./to');
exports.toCallback = to_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/b-apps_b2c-site_b2c-site_develop/node_modules/promise-cb/index.js
// module id = 293
// module chunks = 81